import React, { useMemo } from 'react';
import {
  AccordionList,
  AccordionRow,
  Section,
  ContentFormatter,
  Heading,
  Copy,
  Column,
  Columns,
  RichText
} from '@belong/ui-components';
import { ISectionAccordionList } from './model';

const SectionAccordionList: React.FC<ISectionAccordionList> = ({
  id,
  identifier,
  heading: sectionHeading,
  description,
  accordionRows,
  sectionStyles
}: ISectionAccordionList) => {
  const items = useMemo(
    () =>
      accordionRows.map(({ label, body, headingLevel }) => (
        <AccordionRow key={label} label={label} headingLevel={headingLevel}>
          <RichText {...body} />
        </AccordionRow>
      )),
    [accordionRows]
  );

  return (
    <Section data-testid="section-accordion-list" data-contentid={id} data-identifier={identifier} {...sectionStyles}>
      {(sectionHeading || description) && (
        <ContentFormatter alignment="center">
          <Heading as="h2">{sectionHeading}</Heading>
          <Copy>{description}</Copy>
        </ContentFormatter>
      )}
      <Columns alignX="center">
        <Column width={{ md: '5/6', lg: '2/3', xl: '1/2' }}>
          <AccordionList items={items} />
        </Column>
      </Columns>
    </Section>
  );
};

export default SectionAccordionList;
